import { useEffect, useRef, useState } from 'react';

/**
 * IntersectionObserver — برای انیمیشن ورود به ویوپورت (یک‌بار یا تکراری).
 */
export function useInViewOnce(options = {}) {
  const { rootMargin = '0px 0px -10% 0px', threshold = 0.12, once = true } = options;
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          if (once) observer.unobserve(el);
        } else if (!once) {
          setInView(false);
        }
      },
      { rootMargin, threshold }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [once, rootMargin, threshold]);

  return [ref, inView];
}
